import { useState } from "react";
import { FilterTab } from "../../../../components/Filters";
import Form from "./Form";
import ContractTable from "./ContractTable";
import EditForm from "./EditForm";
import BlockTable from "./BlockTable";

export const DataTabs = [
  { label: "Form", value: "form" },
  { label: "Table", value: "table" },
  { label: "Block-Table", value: "block" },
];

const Contract = () => {
  const [dataTab, setDataTab] = useState(DataTabs[0]);
  return (
    <>
      <div style={{ backgroundColor: "#F5F7FA" }} className=" w-[100%] h-full">
        <div className="bg-white h-[calc(100vh - 110px)] overflow-auto p-5 m-4 rounded-3xl contract-table">
          <div className="gas-heading gap-x-10 items-center border-b-2 border-[#E5E5E5] pb-4">
            <h2 className="text-[18px] text-[#6F6D7C] font-medium ">
              Contract Scheduling
            </h2>
            <FilterTab
              isRounded={true}
              options={DataTabs.map((item) => item.label)}
              selected={[dataTab.label]}
              onClick={(option, index) => {
                setDataTab(DataTabs[index]);
              }}
            />
          </div>
          <div className="w-full ">
            {dataTab.value === "form" ? (
              <Form />
            ) : dataTab.value === "edit" ? (
              <EditForm setDataTab={setDataTab} />
            ) : dataTab.value === "block" ? (
              <BlockTable />
            ) : (
              <ContractTable setDataTab={setDataTab} />
            )}
          </div>
        </div>

        <div className="gna-footer-container">
          <div className="grid grid-cols-2 justify-between gap-5 ">
            <p className="gna-footer-text">
              Powered by <strong>GNA Energy</strong>
            </p>
            <strong className="gna-footer-text  text-end">Beta Version</strong>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contract;
